import { useEffect } from 'react';

import { trackEvent } from './track-event';

const HEARTBEAT_INTERVAL_SEC = 60;

/** Ogni minuto, se la scheda è visibile, registra un tick di "tempo in piattaforma". */
export function useSessionHeartbeat(): void {
  useEffect(() => {
    const interval = setInterval(() => {
      if (document.visibilityState === 'visible') {
        trackEvent('heartbeat', undefined, HEARTBEAT_INTERVAL_SEC);
      }
    }, HEARTBEAT_INTERVAL_SEC * 1000);

    return () => clearInterval(interval);
  }, []);
}
